<template>
  <v-layout row wrap>
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <v-card flat class="futuristic-card">
          <v-card-title class="card-header">
            <h4 class="earth-color">ADD SPECIAL PRICING GROUP</h4>
          </v-card-title>
          <v-container>
            <v-form @submit.prevent="postPricingGroup()">
              <v-text-field
                label="Name"
                v-model="group.name"
                :rules="requiredRules"
                required
                class="futuristic-input"
                outlined
              ></v-text-field>
              <v-btn 
                :depressed="true" 
                color="primary" 
                block 
                v-if="update === false" 
                type="submit"
                class="futuristic-btn"
              >Add Group</v-btn>
              <v-btn 
                :depressed="true" 
                color="warning" 
                block 
                v-if="update === true" 
                type="submit"
                class="futuristic-btn"
              >Update Group</v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
    
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <v-card flat class="futuristic-card">
          <v-card-title class="card-header">
            <h4 class="earth-color">PRICING GROUPS</h4>
          </v-card-title>
          <v-container>
            <table cellpadding="1" cellspacing="1" class="futuristic-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(type, index) in $allPricingGroups" :key="index" class="futuristic-table-row">
                  <td class="futuristic-cell">{{index + 1}}</td>
                  <td class="futuristic-cell">{{type.facility_pricing_name}}</td>
                  <td class="futuristic-cell">
                    <v-btn 
                      :depressed="true" 
                      small 
                      color="error" 
                      v-if="index > 2" 
                      @click="deletePricingGroup(type.facility_pricing_type_public_id)"
                      class="futuristic-btn futuristic-btn-sm"
                    >Disable</v-btn>
                    <v-btn 
                      :depressed="true" 
                      small 
                      color="info" 
                      v-if="index > 2 && update === false" 
                      @click="editPricingGroup(type)"
                      class="futuristic-btn futuristic-btn-sm"
                    >Amend</v-btn>
                    <v-btn 
                      :depressed="true" 
                      small 
                      color="warning" 
                      v-if="index > 1 && update === true" 
                      @click="cancelEditPricingGroup(index)"
                      class="futuristic-btn futuristic-btn-sm"
                    >Cancel Amend</v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SpecialPricingGroups',
  data () {
    return {
      update: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      group: {
        name: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  methods: {
    postPricingGroup () {
      var instance = this
      if (this.update === false) {
        this.$store.dispatch('post_facilitypricingtype', this.group).then(function () {
          instance.cancelEditPricingGroup()
        })
      } else {
        this.$store.dispatch('update_facilitypricingtype', this.group).then(function () {
          instance.cancelEditPricingGroup()
        })
      }
    },
    deletePricingGroup (groupId) {
      var data = {
        facility_price_id: groupId,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_facilitypricingtype', data)
    },
    editPricingGroup (group) {
      this.group.name = group.facility_pricing_name
      Object.assign(this.group, { facility_price_id: group.facility_pricing_type_public_id })
      this.update = true
    },
    cancelEditPricingGroup () {
      this.update = false
      this.group.name = ''
    }
  },
  created () {
    this.$store.dispatch('get_all_facility_pricing_types')
  }
}
</script>

<style scoped>
/* Reuse the same futuristic styles from the parent component */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
}

.earth-color {
  color: #4caf50;
  font-weight: 600;
  margin: 0;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  margin-bottom: 16px;
}

.futuristic-input >>> .v-text-field__slot input {
  font-family: 'Roboto Mono', monospace;
}

.futuristic-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.futuristic-table thead {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

.futuristic-table th {
  color: #4caf50;
  font-weight: 600;
  padding: 12px 8px;
  text-align: left;
  font-size: 13px;
}

.futuristic-table-row {
  transition: background-color 0.2s ease;
}

.futuristic-table-row:hover {
  background-color: #f5f7fa;
}

.futuristic-cell {
  padding: 12px 8px;
  border-bottom: 1px solid #e0e0e0;
  font-family: 'Roboto Mono', monospace;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 4px;
}

.futuristic-btn-sm {
  font-size: 0.85rem;
  padding: 0 12px;
  height: 32px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
  
  .futuristic-table {
    display: block;
    overflow-x: auto;
  }
  
  .futuristic-btn {
    margin: 2px;
    font-size: 0.9rem;
  }
  
  .futuristic-btn-sm {
    font-size: 0.8rem;
    padding: 0 8px;
    height: 28px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }
  
  .card-header {
    border-radius: 6px 6px 0 0;
  }
  
  .futuristic-input >>> .v-input__slot {
    border-radius: 6px;
  }
  
  .futuristic-btn {
    border-radius: 6px;
    width: 100%;
    margin: 4px 0;
  }
  
  .futuristic-cell {
    font-size: 0.85rem;
    padding: 8px 6px;
  }
}
</style>